module.exports = __webpack_public_path__ + "02_long_grey.23214431.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/02_long_grey.png
// module id = wruw
// module chunks = 0